export default __webpack_public_path__ + "static/media/hack4.f5682d90.jpg";